module.exports = __webpack_public_path__ + "static/media/bt.acfa822b.svg";